<script setup lang="ts">
import { reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { useAuthStore } from "../stores/auth";

const auth = useAuthStore();
const router = useRouter();
const route = useRoute();
const loading = ref(false);
const form = reactive({ username: "", password: "" });

async function submit() {
  if (!form.username.trim() || form.password.length < 8) {
    ElMessage.warning("请输入管理员账号和密码");
    return;
  }
  loading.value = true;
  try {
    await auth.login(form.username.trim(), form.password);
    const redirect = typeof route.query.redirect === "string" ? route.query.redirect : "/dashboard";
    await router.replace(redirect);
  } catch (error) {
    ElMessage.error(error instanceof Error ? error.message : "登录失败");
  } finally {
    loading.value = false;
  }
}
</script>

<template>
  <main class="login-page">
    <section class="login-visual">
      <div class="login-grid"></div>
      <div class="visual-top"><span>YMA / 04</span><span>WUHAN · CHINA</span></div>
      <div class="visual-copy">
        <div class="login-wordmark">YMA</div>
        <p>TECHNOLOGY &amp; SERVICE</p>
        <h1>工业服务，<br />每一步都有依据。</h1>
        <h2>Industrial service, clearly managed.</h2>
      </div>
      <div class="machine-drawing" aria-hidden="true">
        <div class="machine-tower"><span></span><i></i></div>
        <div class="machine-console"><span></span></div>
        <div class="machine-line"></div>
      </div>
      <div class="visual-foot"><span>INDUCTION</span><span>AUTOMATION</span><span>SERVICE</span></div>
    </section>

    <section class="login-panel">
      <div class="login-form-wrap">
        <div class="form-number">04</div>
        <span class="form-kicker">SECURE ADMIN ACCESS</span>
        <h2>管理后台登录</h2>
        <p>YMA Service Console</p>

        <form @submit.prevent="submit" class="login-form">
          <label><span>管理员账号</span><small>ADMIN USERNAME</small></label>
          <el-input v-model="form.username" size="large" autocomplete="username" placeholder="请输入管理员账号" @keyup.enter="submit" />
          <label><span>登录密码</span><small>PASSWORD</small></label>
          <el-input v-model="form.password" size="large" type="password" show-password autocomplete="current-password" placeholder="请输入登录密码" @keyup.enter="submit" />
          <el-button native-type="submit" class="login-submit" :loading="loading">进入控制台 <span>ENTER CONSOLE</span></el-button>
        </form>

        <div class="login-help"><span>授权成员专用</span><span>AUTHORIZED PERSONNEL ONLY</span></div>
      </div>
      <footer><span>伊玛（武汉）技术服务有限公司</span><span>© 2026 YMA TECHNOLOGY &amp; SERVICE</span></footer>
    </section>
  </main>
</template>
